<div class="panel">
  <div class="panel-content">
    <glxy-alert type="info" class="description" *ngIf="description">
      {{ description | translate }}
    </glxy-alert>
    <p class="label">{{ 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.PANEL.HEADING' | translate }}</p>
    <ng-container *ngIf="!(existingEmailData$$ | async)?.templateId; else savedComponent">
      <div class="cta">
        <button mat-stroked-button (click)="editEmail()" [disabled]="isTemplateView$ | async">
          {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.PANEL.CREATE_NEW_BUTTON' | translate }}
        </button>
        <button mat-stroked-button (click)="handleSelectExistingEmail()" [disabled]="isTemplateView$ | async">
          {{ 'CAMPAIGN_DETAILS.ADD_TEMPLATE.ADD_EXISTING' | translate }}
        </button>
      </div>
      <glxy-hint *ngIf="isTemplateView$ | async">
        {{ 'AUTOMATIONS.COMMON.DISABLED_DUE_TO_TEMPLATE' | translate }}
      </glxy-hint>
    </ng-container>

    <ng-template #savedComponent>
      <div class="preview">
        <button class="btn" (click)="removeSelectedEmail()">
          <mat-icon>cancel</mat-icon>
        </button>
        <automata-preview-image-container [imageUrl]="previewImageUrl$ | async"></automata-preview-image-container>
        @if (previewImageUrlLoading()) {
          <glxy-progress-bar isLoading="true" />
        }
      </div>
      <div class="preview-action-buttons">
        <button mat-flat-button (click)="editEmail()" color="primary" [disabled]="!emailIsEditable()">
          {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.EMAIL_BUILDER.EDIT_EMAIL' | translate }}
        </button>
        <button mat-stroked-button (click)="handleSelectExistingEmail()">
          {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.EMAIL_BUILDER.REPLACE_EMAIL' | translate }}
        </button>
      </div>
      <email-stats
        [attribute]="{ key: 'automation_step_id', value: step?.id }"
        [backUrl]="backUrl"
        [senderType]="senderType"
      ></email-stats>
    </ng-template>
  </div>
</div>
